import React from "react";
import { FormattedDate } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { setSidebar } from "amadeusredux/lib/systemSlice";
import InfoPopupHover from "../components/InfoPopupHover";
import { crtobr, views } from "../utils";
import { CgMoreR } from "react-icons/cg";
import { fetchSessionHistory } from "amadeusredux/lib/propertiesSlice";
import { selectSearch } from "amadeusredux/lib/searchSlice";

export default function SearchParameter(props) {
  const dispatch = useDispatch();

  const offerInfos = useSelector((state) => state.offers.offerInfos);
  const holidayType = useSelector((state) => state.search.holidayType);
  const hotelOfferInfos = useSelector((state) => state.hotel.hotelOfferInfos);
  const sidebar = useSelector((state) => state.system.sidebar);
  const view = useSelector((state) => state.system.view);
  const searchOptions = useSelector(selectSearch);

  let offers = offerInfos.Offers ? offerInfos.Offers.Offer : [];

  const sessionId = useSelector((state) => state.system.sessionId);

  if (
    (view === views.hotelclassicview || view === views.hotelcrossview) &&
    hotelOfferInfos.Offers
  ) {
    offers = hotelOfferInfos.Offers ? hotelOfferInfos.Offers.Offer : [];
  }

  let destinationstring = "";

  if (offers.length > 0 && offers[0].displaydestination.length > 0) {
    for (let i = 0; i < offers[0].displaydestination.length; i++) {
      destinationstring =
        destinationstring +
        "<span>" +
        offers[0].displaydestination[i].label +
        ",<br/></span>";
    }
  }

  let travellerstring = "";
  if (offers.length > 0) {
    if (offers[0].adults !== "0") {
      travellerstring =
        travellerstring +
        "<span>" +
        offers[0].adults +
        " Erwachsene" +
        "<br/></span>";
    }
    if (offers[0].adults !== "0") {
      if (offers[0].children == "1") {
        travellerstring =
          travellerstring +
          "<span>" +
          offers[0].children +
          " Kind" +
          "<br/></span>";
      } else {
        travellerstring =
          travellerstring +
          "<span>" +
          offers[0].children +
          " Kinder" +
          "<br/></span>";
      }
    }
  }

  let stationsstring = "";
  if (
    Array.isArray(offers) &&
    offers.length > 0 &&
    Array.isArray(offers[0].stations) &&
    offers[0].stations.length > 0
  ) {
    for (let i = 0; i < offers[0].stations.length; i++) {
      stationsstring =
        stationsstring +
        "<span>" +
        offers[0].stations[i].label +
        ",<br/></span>";
    }
  }

  //console.log(searchOptions);

  return (
    <>
      {!sidebar && (
        <div
          className="offersearch"
          style={{ marginTop: 25, marginBottom: 25, display: "flex" }}
        >
          <div className="offerinfo" style={{ flexGrow: 1 }}>
            {offers[0] && (
              <>
                {offers[0].displaydestination.map((e) => e.label).join(", ")
                  .length > 15 ? (
                  <InfoPopupHover
                    trigger={
                      <div className="offersearchdestination">
                        {" "}
                        Reiseziel{" "}
                        {offers[0].displaydestination
                          .map((e) => e.label)
                          .join(", ")
                          .substring(0, 15)}{" "}
                        {offers[0].displaydestination
                          .map((e) => e.label)
                          .join(", ").length > 15 ? (
                          <CgMoreR className="moreIcon" />
                        ) : (
                          ""
                        )}
                      </div>
                    }
                    content={
                      /*offers[0].destination
                      .map((e) => e.label)
                  .join(", \n")*/ destinationstring
                    }
                    position={"bottom center"}
                  ></InfoPopupHover>
                ) : (
                  <div className="offersearchdestination">
                    {" "}
                    Reiseziel{" "}
                    {offers[0].displaydestination
                      .map((e) => e.label)
                      .join(", ")
                      .substring(0, 15)}{" "}
                    {offers[0].displaydestination.map((e) => e.label).join(", ")
                      .length > 15 ? (
                      <CgMoreR className="moreIcon" />
                    ) : (
                      ""
                    )}
                  </div>
                )}

                {(
                  offers[0].adults +
                  " Erwachsene" +
                  (offers[0].children > 0
                    ? " " + offers[0].children + " Kinder "
                    : " ")
                ).length > 15 ? (
                  <InfoPopupHover
                    trigger={
                      <div className="offersearchtravellers">
                        {" "}
                        {(
                          offers[0].adults +
                          " Erwachsene" +
                          (offers[0].children > 0
                            ? offers[0].children == "1"
                              ? " " + offers[0].children + " Kind "
                              : " " + offers[0].children + " Kinder "
                            : " ")
                        ).substring(0, 15)}{" "}
                        {(
                          offers[0].adults +
                          " Erwachsene" +
                          (offers[0].children > 0
                            ? " " + offers[0].children + " Kinder "
                            : " ")
                        ).length > 15 ? (
                          <CgMoreR className="moreIcon" />
                        ) : (
                          ""
                        )}
                      </div>
                    }
                    content={
                      /*offers[0].adults +
                      " Erwachsene" +
                      (offers[0].children > 0
                        ? " " + offers[0].children + " Kinder "
                        : " ")*/ travellerstring
                    }
                    position={"bottom center"}
                  ></InfoPopupHover>
                ) : (
                  <div className="offersearchtravellers">
                    {" "}
                    {(
                      offers[0].adults +
                      " Erwachsene" +
                      (offers[0].children > 0
                        ? " " + offers[0].children + " Kinder "
                        : " ")
                    ).substring(0, 15)}{" "}
                    {(
                      offers[0].adults +
                      " Erwachsene" +
                      (offers[0].children > 0
                        ? " " + offers[0].children + " Kinder "
                        : " ")
                    ).length > 15 ? (
                      <CgMoreR className="moreIcon" />
                    ) : (
                      ""
                    )}
                  </div>
                )}
                

                <div className="offersearchdate">
                  {" "}
                  {offers[0].travelDate && (
                    <FormattedDate
                      value={new Date(JSON.parse(offers[0].travelDate))}
                    />
                  )}
                  {" - "}
                  <FormattedDate
                    value={new Date(JSON.parse(searchOptions.travelDate.to))}
                  />
                </div>
                {offers[0].duration && (
                  <>
                    {offers[0].duration.length > 15 ? (
                      <InfoPopupHover
                        trigger={
                          <div className="offersearchduration">
                            {" "}
                            {offers[0].duration.substring(0, 15)}
                            {offers[0].duration.length > 15 ? (
                              <CgMoreR className="moreIcon" />
                            ) : (
                              ""
                            )}
                          </div>
                        }
                        content={offers[0].duration}
                        position={"bottom center"}
                      ></InfoPopupHover>
                    ) : (
                      <div className="offersearchduration">
                        {" "}
                        {offers[0].duration.substring(0, 15)}
                        {offers[0].duration.length > 15 ? (
                          <CgMoreR className="moreIcon" />
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </>
                )}
                {holidayType?.flight &&
                  Array.isArray(offers) &&
                  offers.length > 0 &&
                  Array.isArray(offers[0].stations) &&
                  (offers[0].stations.map((e) => e.label).join(", ").length >
                  15 ? (
                    <InfoPopupHover
                      trigger={
                        <div className="offersearchstations">
                          {" "}
                          {offers[0].stations
                            .map((e) => e.label)
                            .join(", ")
                            .substring(0, 15)}{" "}
                          {offers[0].stations.map((e) => e.label).join(", ")
                            .length > 15 ? (
                            <CgMoreR className="moreIcon" />
                          ) : (
                            ""
                          )}
                        </div>
                      }
                      content={
                        /*offers[0].stations
                      .map((e) => e.label)
                  .join(", \n")*/ stationsstring
                      }
                      position={"bottom center"}
                    ></InfoPopupHover>
                  ) : (
                    <div className="offersearchstations">
                      {" "}
                      {Array.isArray(offers) &&
                        offers.length > 0 &&
                        Array.isArray(offers[0].stations) &&
                        offers[0].stations
                          .map((e) => e.label)
                          .join(", ")
                          .substring(0, 15)}{" "}
                      {Array.isArray(offers) &&
                      offers.length > 0 &&
                      Array.isArray(offers[0].stations) &&
                      offers[0].stations.map((e) => e.label).join(", ").length >
                        15 ? (
                        <CgMoreR className="moreIcon" />
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
              </>
            )}
          </div>
          <div style={{ width: 180, textAlign: "right" }}>
            <span
              className="offerframe9"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(fetchSessionHistory({ sessionid: sessionId }));
                dispatch(setSidebar(true));
              }}
            >
              Suche anpassen
            </span>
          </div>
        </div>
      )}
    </>
  );
}
